import {
  AddressSearch,
  Collapsible,
  useModelFormUpdate,
} from '@equifinance/shared';
import { v4 as uuid } from 'uuid';
import { Fragment } from 'react';
import styled from 'styled-components';
import { AccountButton, AccountButtonContainer } from '../../components/Buttons';
import { StaticDataItem } from '../../../../api/useAccountApi';
import { Stages } from '../../../../types/Stages';
import { useAccountContext } from '../../../../contexts';

const CollapsibleBodyWrapper = styled.div`${({ theme }) => `
  padding-top: ${theme.padding[4]};
`}`;

export default function SecurityAddressDetails({
  ukCountries,
  lendingRegions,
}: {
  ukCountries: StaticDataItem[],
  lendingRegions: StaticDataItem[],
  }) {
  const { account, creditSearchCompleted } = useAccountContext();

  const {
    stage,
    securityAddress,
    applicants,
    errors,
  } = account;

  const update = useModelFormUpdate();

  const copyApplicantAddress = (applicantIndex: number) => {
    const applicantCurrentAddress = applicants?.[applicantIndex]?.addresses?.find((address) => address?.isCurrentAddress);

    if (applicantCurrentAddress) {
      update({
        'securityAddress': {
          ...applicantCurrentAddress?.address,
          id: uuid(),
        },
      });
    }
  };

  return (
    <Collapsible
      id="security-address"
      title="Security address"
      level={1}
    >
      <CollapsibleBodyWrapper>
        <AccountButtonContainer>
          {applicants?.map((applicant, applicantIndex) => (
            <Fragment key={`copy-applicant-${applicantIndex + 1}-current-address`}>
              {!creditSearchCompleted && Object.values(ukCountries ?? [])
                .map((country) => country?.key)
                .includes(applicant?.addresses?.find((address) => address.isCurrentAddress)?.address?.country ?? '')
              && (
                <AccountButton
                  id={`copy-applicant-${applicantIndex + 1}-current-address`}
                  onClick={() => copyApplicantAddress(applicantIndex)}
                >
                  {`Copy current address of Applicant ${applicants.length > 1 ? applicantIndex + 1 : ''}`}
                </AccountButton>
              )}
            </Fragment>
          ))}
        </AccountButtonContainer>

        <AddressSearch
          field="securityAddress"
          addressId={securityAddress?.id}
          searchPlaceholder="Enter postcode or first line of security address"
          countries={lendingRegions?.reduce((prev, country) => ({
            ...prev,
            [country?.key]: country?.label,
          }), {} as Record<string, string>)}
          disabled={stage !== Stages.CreditDecision || creditSearchCompleted}
          limitToGreatBritain
          errors={errors}
          subBuildingLabel="Flat number"
          buildingNameLabel="House name"
          buildingNumberLabel="House number"
        />
      </CollapsibleBodyWrapper>
    </Collapsible>
  );
}
